import {Pipe, PipeTransform} from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

@Pipe({name: 'duration'})
export class DurationPipe implements PipeTransform {
	transform(fromDate: string | Date, toDate: string | Date): string {
		const from = dayjs(fromDate);
		const to = dayjs(toDate);
		if (!from?.isValid() || !to.isValid()) {
			return '—';
		}

		return to.from(from, true);
	}
}
